import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./fr.json";
import en from "./en.json";
import es from "./es.json";
import it from "./it.json";
import ar from "./ar.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    es: { translation: es },
    it: { translation: it },
    ar: { translation: ar },
  },
  fallbackLng: "en",
  supportedLngs: ["fr", "en", "es", "it", "ar"],
  nonExplicitSupportedLngs: true,
  interpolation: { escapeValue: false },
  detection: {
    // English is the primary language: only an explicit visitor choice overrides it
    order: ["localStorage"],
    caches: ["localStorage"],
    lookupLocalStorage: "i18nLang_v2",
  },
});

// Keep <html lang> in sync with the active language
if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language;
  document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    // Subtle fade transition on language change (no full page refresh)
    try {
      const root = document.documentElement;
      root.classList.add("lang-switching");
      window.setTimeout(() => root.classList.remove("lang-switching"), 350);
    } catch {}
  });
}

export default i18n;
